import React, { useEffect, useState } from 'react';

import { useAuth } from "../../contexts/AuthContexts"
import { useUser } from "../../contexts/UserContexts"

import { db } from '../../firebase';
import { getDoc, doc } from "firebase/firestore";

import { Container, Content } from "./styles";

export const WeekGraph = () => {

    const [ weekResults, setWeekResults] = useState([]);

    const { currentUser } = useAuth();
    const { userInfo } = useUser();

    const getWeekResult = async () => {
        if(!currentUser || !currentUser.uid) return;

        // pegando dias da semana atual
        const currentDate = new Date();
        const currentWeek = new Date(currentDate.setDate(currentDate.getDate() - (currentDate.getDay() + 6)%7));

        try {
            const userData = userInfo;

            if(!!userData){
                const date = currentWeek;
                const auxWeekResults = [[0, "Seg"], [0, "Ter"], [0, "Qua"], [0, "Qui"], [0, "Sex"], [0, "Sáb"], [0, "Dom"]]
                for(let i = 0; i < 7; i++){
                    const isoDate = String(date.getFullYear() + "-" + String(parseInt(date.getMonth() + 1)).padStart(2, '0') + "-" + String(date.getDate()).padStart(2, '0'));
                    auxWeekResults[i][0] = (userData.dietDaysMap[isoDate] ? 1 : 0) +  (userData.trainingDaysMap[isoDate] ? 1 : 0) +  (userData.cardioDaysMap[isoDate] ? 1 : 0);
                    date.setDate(date.getDate() + 1);
                }
                setWeekResults(auxWeekResults);
            }
        } catch (e) {
            console.log(e);
        }
    };

    useEffect(()=>{
        getWeekResult();
    }, []);

    return (
        <Container>
            <Content> 
                <div className="general">
                    <div>Atividade (dieta, treino e cardio)</div>
                        <div className="box-content">
                            {weekResults.map((day, idx) =>(
                                <div key={String(idx) + "box"} className="box">
                                    <div key={String(idx) + "bar"} className="bar">
                                        <div key={String(idx) + "bar-percentage"} style={{height: `${(day[0]/3) * 100}%`}} className="bar-percentage"></div>
                                    </div>
                                    <div key={String(idx) + "week"}>{day[1]}</div>
                                </div>
                            ))}
                        </div>
                </div>
            </Content>    
        </Container>
    );
};


